import { useEffect } from 'react';
import { authenticatedFetch, getApiBase } from '../utils/api';

// Preload critical dashboard data when the app starts
export default function useDashboardPreload() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const pathname = window.location.pathname || '';
    const shouldPreloadDashboard = pathname === '/' || pathname === '/dashboard';
    if (!shouldPreloadDashboard) {
      return undefined;
    }

    // Preload dashboard data in the background
    const preloadDashboardData = async () => {
      try {
        const API_BASE_URL = getApiBase();

        // Preload the same URLs the dashboard uses so the first visit is warm.
        const orderStatsUrl = `${API_BASE_URL}/get-dashboard-order-stats`;
        const invCountUrl = `${API_BASE_URL}/inventory?page=1&pageSize=1&filter=all`;
        const breakdownUrl = `${API_BASE_URL}/getInventoryEbayCategoryBreakdown`;
        const invStatsUrl = `${API_BASE_URL}/getInventoryStats`;
        const financialsUrl = `${API_BASE_URL}/get-dashboard-financials-comparison`;
        const topSellersUrl = `${API_BASE_URL}/get-dashboard-top-sellers`;
        const revenueTrendUrl = `${API_BASE_URL}/get-dashboard-revenue-trend`;
        const recentOrdersUrl = `${API_BASE_URL}/get-ebay-orders?filter=all&page=1&pageSize=5&dateRange=7`;
        const newItemsUrl = `${API_BASE_URL}/inventory?filter=to_be_listed&page=1&pageSize=5&daysAgo=7`;
        
        // Start preloading but don't wait for completion
        Promise.all([
          authenticatedFetch(orderStatsUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(invCountUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(breakdownUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(invStatsUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(financialsUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(topSellersUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(revenueTrendUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(recentOrdersUrl, { headers: { 'Accept': 'application/json' } }),
          authenticatedFetch(newItemsUrl, { headers: { 'Accept': 'application/json' } })
        ]).catch(() => {
          // Silently handle preload failures
        });
      } catch (error) {
        // Silently handle preload errors
      }
    };

    // Delay preload slightly to not interfere with initial page load
    const timeoutId = setTimeout(preloadDashboardData, 1000);
    
    return () => clearTimeout(timeoutId);
  }, []);
}
